module.exports = __webpack_public_path__ + "img/icon-my-transfers.3d4d218c.svg";